/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect } from 'react';
import IconChevronLeft from '@zvuk-b2b/react-uikit/ui/icons/ChevronLeft';
import IconButton from '@zvuk-b2b/react-uikit/ui/IconButton';
import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';
import { MediaPreviewDialogProps } from './types';
import { ELEMENT_IDS } from './consts';

const MediaPreviewDialog: React.FC<MediaPreviewDialogProps> = ({
  children,
  onClose,
  layoutClassName,
  overlayClassName,
  backButtonClassName,
  modalTestId,
  closeTestId,
}) => {
  const { isMobile } = useMedia();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div>
      <div
        className={layoutClassName}
        data-testid={modalTestId}>
        {isMobile && (
          <IconButton
            onClick={onClose}
            className={backButtonClassName}
            elementId={ELEMENT_IDS.MOBILE_BACK}>
            <IconChevronLeft />
          </IconButton>
        )}
        {children}
        <div
          className={overlayClassName}
          data-testid={closeTestId}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default MediaPreviewDialog;
